import React, { FC } from 'react';
import { UniversalLink } from '@/components';
import { TypeBreadcrumbTreeFields } from '@/core/generated-types';
import classNames from 'classnames';
import { getCtaTextStyles } from '@/components/utils';

interface BreadcrumbTreeProps extends TypeBreadcrumbTreeFields {
  classes?: string;
}

const BreadcrumbTree: FC<BreadcrumbTreeProps> = ({
  leaf,
  branches,
  classes,
}) => {
  if (!branches || !leaf) return null;

  return (
    <div
      data-testid="breadcrumb-tree"
      className={classNames('mt-6 flex flex-wrap gap-1', classes)}
    >
      {branches?.map((branch) => (
        <div className="flex" key={branch.sys.id}>
          <UniversalLink
            link={branch}
            key={branch.sys.id}
            classes={`font-bold underline ${getCtaTextStyles()}`}
          />
          <p className="ml-1">/</p>
        </div>
      ))}
      <span>{leaf}</span>
    </div>
  );
};

export default BreadcrumbTree;
